import { Component, OnInit } from '@angular/core';
import { Postulante } from '../../models/Postulante';
import { PostulanteService } from '../../services/postulante.service';
import { PostulanteApiRestService } from '../../services/postulanteApiRest.service';

@Component({
  selector: 'app-seccionPostulante',
  templateUrl: './seccionPostulante.component.html',
  styleUrls: ['./seccionPostulante.component.css']
})
export class SeccionPostulanteComponent implements OnInit {

  postulantes : Postulante[];
  postulantes_aux: Postulante[];

  constructor(
    private postulanteService: PostulanteService,
    private postulanteApiRestService: PostulanteApiRestService
  ) { }

  ngOnInit() {
    //uno
    this.postulanteService.getPostulantes().subscribe((response) => {
      this.postulantes = response;
      console.log('Postulantes: ', response);
    })

    //dos
    this.postulanteApiRestService.getPostulantes().subscribe( (response) => {
      this.postulantes_aux = response;
      console.log('Postulantes AUX: ', response);
    })
  }

}
